"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./StepIndicator.css");
var StepIndicatorProps_1 = require("./StepIndicatorProps");
var StepIndicator = /** @class */ (function (_super) {
    __extends(StepIndicator, _super);
    function StepIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StepIndicator.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: this.props.options && this.props.options.customClass ? this.props.options.customClass : '' },
            React.createElement("ul", { className: styles.stepindicator + ' ' + this.getClassName(this.props.data), id: this.guid() }, this.buildOptions(this.props.data))));
    };
    StepIndicator.prototype.getClassName = function (dataInput) {
        return StepIndicatorProps_1.stylesMap.get('item' + dataInput.choices.length);
    };
    StepIndicator.prototype.buildOptions = function (dataInput) {
        var _this = this;
        return dataInput.choices.map(function (choice, index) {
            var wrapperCls = _this.props.options && (_this.props.options.setAlignment === 'left') ?
                [styles.leftAligned, choice.isSelected ? styles.done : ''].join(' ') :
                _this.props.options && (_this.props.options.setAlignment === 'right') ?
                    [styles.rightAligned, choice.isSelected ? styles.done : ''].join(' ') :
                    [choice.isSelected ? styles.done : ''].join(' ');
            return (React.createElement("li", { tabIndex: 0, key: index, className: wrapperCls, "data-selected": choice.isSelected ? true : false },
                React.createElement("span", { "aria-hidden": "true" }, choice.displayText),
                React.createElement("span", { className: styles.hiddenSpoken }, 'Step ' + (index + 1) + ' of ' + dataInput.choices.length + '. ' +
                    choice.accessibilityText + '. ' + (choice.isSelected && choice.isCompleted ? 'Completed' : (choice.isSelected ? 'Current Step' : 'Remaining Step')))));
        });
    };
    StepIndicator.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    StepIndicator.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return StepIndicator;
}(React.Component));
exports.default = StepIndicator;
//# sourceMappingURL=StepIndicator.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/StepIndicator/StepIndicator.js
// module id = 1258
// module chunks = 8